var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeSphericalCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9.06316,20.4607)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 99,
    r: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.06316,-5.68434e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.5,120C158.437,166.662 150.172,204.461 140,204.461C129.828,204.461 121.563,166.662 121.5,120L158.5,120Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.06316,-5.68434e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.958,120C223.542,129.203 186.017,136.587 140,136.587C93.983,136.587 56.458,129.203 55.042,120L224.958,120Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.06316,-5.68434e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.995,120C224.543,149.595 186.631,173.535 140,173.535C93.369,173.535 55.457,149.595 55.005,120L224.995,120Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.06316,-5.68434e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.997,120C224.642,158.389 186.692,189.461 140,189.461C93.308,189.461 55.358,158.389 55.003,120L224.997,120Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.06316,-5.68434e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.499,120C192.317,166.662 168.303,204.461 138.75,204.461C109.197,204.461 85.183,166.662 85.001,120L192.499,120Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.06316,-5.68434e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.499,120C213.25,166.662 180.412,204.461 140,204.461C99.588,204.461 66.75,166.662 66.501,120L213.499,120Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,54.2189,126.926)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.391018,-0.391018,0.173843,0.173843,51.5475,168.616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.673,106.4L33.673,121.324L15.98,101.425L33.673,81.527L33.673,96.451L167.431,96.451L167.431,81.527L167.431,121.324L167.431,106.4L33.673,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,15.3916,114.847)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "r")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-58.5346,127.078)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "h")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.26908e-17,0.533882,-0.245851,1.5054e-17,60.9803,110.929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.306,106.4L34.306,121.324L15.98,101.425L34.306,81.527L34.306,96.451L149.105,96.451L149.105,81.527L167.431,101.425L149.105,121.324L149.105,106.4L34.306,106.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeSphericalCap);
export default __webpack_public_path__ + "static/media/calc-figure-volume-sphericalCap.850c045430ed734baea3c621122248b9.svg";
export { ForwardRef as ReactComponent };